// Copyright (c) StrangeBee 2023

import { Select } from 'antd';
import React, { forwardRef } from 'react';
import { ListItemsPerPage, ListItemsPerPageType } from '@Constants/pagination';
import { useLocalMessage } from '@Helpers/';
import { LayoutPaginationOptions } from '@Types';
import { THSelect } from '@Molecules/Inputs/THSelect/THSelect';

import './PaginationSize.scss';

interface PaginationSizeProps {
    paginationConfig?: Pick<LayoutPaginationOptions, 'itemsPerPage' | 'onItemsPerPageChange'>;
    hidden?: boolean;
    value?: ListItemsPerPageType;
    onChange?: (value: number) => void;
    showLabel?: boolean;
}

export const PaginationSize = forwardRef<HTMLDivElement, PaginationSizeProps>(
    ({ paginationConfig, hidden = false, value, onChange, showLabel = true }, ref) => {
        const i = useLocalMessage();
        const { itemsPerPage, onItemsPerPageChange } = paginationConfig || {};

        const scrollToTop = () => {
            (ref as any)?.current?.scrollIntoView({
                behavior: 'smooth',
            });
        };

        return !hidden ? (
            <div className="pagination-size">
                {showLabel && <span>{i('list.header.list-count')}</span>}
                <THSelect
                    value={value || itemsPerPage}
                    onChange={(value) => {
                        onChange?.(value) || onItemsPerPageChange?.(value);
                        scrollToTop();
                    }}
                    className="pagination-size__display"
                >
                    {ListItemsPerPage.map((value) => (
                        <Select.Option value={value} key={value} className="pagination-size__option">
                            {value}
                        </Select.Option>
                    ))}
                </THSelect>
            </div>
        ) : null;
    },
);
